import _ from "lodash";

export type Category = {
  description: string;
  id: string;
  emoji: string;
};

export const whatWentWellCategories: Array<Category> = [
  {
    description: "My Interviewer(s)",
    id: "interviewer",
    emoji: "✍️",
  },
  {
    description: "Interview format",
    id: "interview-format",
    emoji: "📝",
  },
  {
    description: "Timeliness",
    id: "timeliness",
    emoji: "⏰",
  },
  {
    description: "My Recruiter",
    id: "recruiter",
    emoji: "🙌",
  },
  {
    description: "Interview Scheduling",
    id: "interview-scheduling",
    emoji: "📅",
  },
];

export const whatCouldBeBetterCategories: Array<Category> = _.union(
  whatWentWellCategories,
  [
    {
      description: "Technical difficulties",
      id: "technical-difficulties",
      emoji: "☎️",
    },
  ]
);

const allCategories: Array<Category> = whatCouldBeBetterCategories;

export default allCategories;
